import * as React from 'react'

import * as styles from './Footer.module.less'

export interface FooterProps {
    content?: React.ReactNode
}

export const Footer: React.FC<FooterProps> = props => {
    return (
        <div className={styles.footer}>
            {/* <div>test</div>      */}
            {props.content}
            {props.children}
        </div>
    )
}
/**
 * position: fixed;
    right: 50px;
    margin-top: -40px;
 */
